<template>
    <div>
        <side-bar layout="admin"></side-bar>
        <div class="content ht-100v pd-0">

            <Header></Header>

            <router-view></router-view>


        </div>

    </div>
</template>

<script>
    // @ is an alias to /src
    import Header from "../../../components/menu/Header";
    import SideBar from "../../../components/menu/Sidebar";
    import { mapState } from "vuex"
    import PerfectScrollbar from "perfect-scrollbar";

    export default {
        name: 'Home',
        components: {SideBar, Header},
        methods:{
            init: async function () {
                await this.$store.dispatch("auth/userdetails", {}).then(
                    result => {
                        if (result.responsecode !== "00")
                            localStorage.clear(); else {
                            this.loaddata(result.customerid)
                        }
                    }).catch(err => {
                        console.log(err.body);
                        localStorage.clear();
                    }
                );
            },
            loaddata: async function () {
                //const payload = {customerid: customerid, status:  this.auth.response.roles === 'ROLE_AUTHORIZER' ? 'completed' : 'pushed'};
                await this.$store.dispatch("admin/readAllBatches");
                await this.$store.dispatch("admin/readAllUsers");
                await this.$store.dispatch("admin/readAllCompanies");
            }
        },
        created(){
            this.init();
        },
        computed:{
            ...mapState(['auth'])
        },
        mounted() {
            const psSidebar = new PerfectScrollbar('#sidebarMenu', {
                suppressScrollX: true
            });
            const psNavbar = new PerfectScrollbar('#navbarMenu', {
                suppressScrollX: true
            });
            console.log(psNavbar);
            console.log(psSidebar)
        }



    }
</script>
